import { payload } from "../../../../../node_modules/@sveltejs/kit/src/runtime/client/payload.js";
const env = payload.env;

export const PUBLIC_LANG = env.PUBLIC_LANG;
export const PUBLIC_TIME_ZONE = env.PUBLIC_TIME_ZONE;
export const PUBLIC_TIME_LOCALE = env.PUBLIC_TIME_LOCALE;
export const PUBLIC_TIME_HOUR_FORMAT = env.PUBLIC_TIME_HOUR_FORMAT;
export const PUBLIC_TIME_START_OF_WEEK = env.PUBLIC_TIME_START_OF_WEEK;
export const PUBLIC_TECHNICAL_SUPPORT_EMAIL = env.PUBLIC_TECHNICAL_SUPPORT_EMAIL;
export const PUBLIC_MAX_IMAGE_DIMENSION = env.PUBLIC_MAX_IMAGE_DIMENSION;
export const PUBLIC_IMAGE_QUALITY = env.PUBLIC_IMAGE_QUALITY;
export const PUBLIC_MAX_IMAGE_FILE_SIZE = env.PUBLIC_MAX_IMAGE_FILE_SIZE;
export const PUBLIC_MAX_VIDEO_FILE_SIZE = env.PUBLIC_MAX_VIDEO_FILE_SIZE;
export const PUBLIC_MAX_VIDEO_DIMENSION = env.PUBLIC_MAX_VIDEO_DIMENSION;
export const PUBLIC_ALLOW_MEMBER_POSTERS = env.PUBLIC_ALLOW_MEMBER_POSTERS;
export const PUBLIC_MAX_VIDEO_DURATION = env.PUBLIC_MAX_VIDEO_DURATION;
export const PUBLIC_SHOW_BLOCK_GRID_LINES = env.PUBLIC_SHOW_BLOCK_GRID_LINES;
export const PUBLIC_SHOW_DEBUG_STYLES = env.PUBLIC_SHOW_DEBUG_STYLES;
export const PUBLIC_IMAGE_AVIF_EFFORT = env.PUBLIC_IMAGE_AVIF_EFFORT;
export const PUBLIC_GRAPHIC_ENTROPY_THRESHOLD = env.PUBLIC_GRAPHIC_ENTROPY_THRESHOLD;
export const PUBLIC_WEEK_START = env.PUBLIC_WEEK_START;
export const PUBLIC_WEEK_END = env.PUBLIC_WEEK_END;
export const PUBLIC_DAY_START = env.PUBLIC_DAY_START;
export const PUBLIC_DAY_END = env.PUBLIC_DAY_END;
export const PUBLIC_MIN_CANCELLATION_MINUTES_HALF_HOURLY_BOOKINGS = env.PUBLIC_MIN_CANCELLATION_MINUTES_HALF_HOURLY_BOOKINGS;
export const PUBLIC_DAILY_BOOKING_HOUR_OF_DAY_FOR_SENDING_REMINDERS = env.PUBLIC_DAILY_BOOKING_HOUR_OF_DAY_FOR_SENDING_REMINDERS;
export const PUBLIC_SEPA_BILLING_DAYS_BEFORE_MONTH_END = env.PUBLIC_SEPA_BILLING_DAYS_BEFORE_MONTH_END;
export const PUBLIC_BOOKING_WINDOW_SIZE_MEETING_ROOM = env.PUBLIC_BOOKING_WINDOW_SIZE_MEETING_ROOM;
export const PUBLIC_BOOKING_WINDOW_SIZE_FLEX_DESK = env.PUBLIC_BOOKING_WINDOW_SIZE_FLEX_DESK;
export const PUBLIC_BOOKING_WINDOW_SIZE_OPEN_DAY = env.PUBLIC_BOOKING_WINDOW_SIZE_OPEN_DAY;
export const PUBLIC_BOOKING_WINDOW_SIZE_FIXED_DESK = env.PUBLIC_BOOKING_WINDOW_SIZE_FIXED_DESK;
export const PUBLIC_BOOKING_WINDOW_SIZE_OFFICE = env.PUBLIC_BOOKING_WINDOW_SIZE_OFFICE;
export const PUBLIC_BOOKING_WINDOW_SIZE_ADDON = env.PUBLIC_BOOKING_WINDOW_SIZE_ADDON;
export const PUBLIC_CANCELLATION_NOTICE_PERIOD_OFFICE = env.PUBLIC_CANCELLATION_NOTICE_PERIOD_OFFICE;
export const PUBLIC_CANCELLATION_NOTICE_PERIOD_FIXED_DESK = env.PUBLIC_CANCELLATION_NOTICE_PERIOD_FIXED_DESK;
export const PUBLIC_CANCELLATION_NOTICE_PERIOD_ADDON = env.PUBLIC_CANCELLATION_NOTICE_PERIOD_ADDON;
export const PUBLIC_MIN_REMAINING_MINUTES_FOR_BOOKING_OF_HALF_HOURLY_SLOT = env.PUBLIC_MIN_REMAINING_MINUTES_FOR_BOOKING_OF_HALF_HOURLY_SLOT;
